import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import Grid from "@material-ui/core/Grid";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import BrandYaragh from "../Yaragh/components/BrandYaragh/BrandYaragh";
import MahdoodeFaniYaraghTable from "./components/MahdoodeFani/MahdoodeFaniYaraghTable";
import { useDispatch, useSelector } from "react-redux";
import ChangeGroupPrice from "./components/ChangeGroupPrice/ChangeGroupPrice";
import ArchiveDialog from "./components/ArchiveDialog/ArchiveDialog";
import { read } from "Helpers/LocalStorage";
import { getAllYaragh, setNameForSearchBazshoYaragh, setNameForSearchBrandYaragh } from "Stores/actions";
import Bazsho from "./components/Bazsho/Bazsho";
import NewMahdoode from "./components/NewMahdoode/NewMahdoode";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";
import NewMahdoodeFani from "./components/MahdoodeFani/components/NewMahdoodeFani";
import ManageStuff from "./components/MahdoodeFani/components/StuffFitting/ManageStuff";
import { Divider } from "@material-ui/core";
import MahdoodeManager from "./components/MahdoodeManager";

function Yaragh() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedBazsho } = useSelector((state) => ({ selectedBazsho: state.yaragh.selectedBazsho }));

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        dispatch(setNameForSearchBazshoYaragh(""));
        dispatch(setNameForSearchBrandYaragh(""));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllYaragh(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button side-button my-2">
        <PageTitle title={<Translator id={"fitting"} />} />
        <div className="top-buttons">
          <div>
            <ArchiveDialog />
          </div>
          <div>
            {(read("yaraghRules").accessRegister !== false) && <NewMahdoode />}
            <ChangeGroupPrice />
            {
              (selectedBazsho && (
                (selectedBazsho.IsG && read("StypeU") === "1") || 
                (!selectedBazsho.IsG && read("yaraghRules")?.accessRegister && (read("StypeU") === "2" || read("StypeU") === "5"))
              )) && 
              <>
                <Divider orientation="vertical" flexItem className="mx-1" />
                <NewMahdoodeFani />
                <ManageStuff />
              </>
            }
          </div>
        </div>
      </div>
      <Grid container spacing={3}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <Grid item className="secondaryPaper">
            <MuiPaper className="no-padding">
              <BrandYaragh />
            </MuiPaper>
          </Grid>
          <Grid item className="secondaryPaper mt-3">
            <MuiPaper className="no-padding">
              <Bazsho />
            </MuiPaper>
          </Grid>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <MahdoodeManager />
        </Grid>
      </Grid>
    </>
  );
}

export default Yaragh;
